import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/innvoice_qr_code.png'
import _imports_1 from '@/assets/images/normer.png'
import _imports_2 from '@/assets/images/special.png'


const _withScopeId = n => (_pushScopeId("data-v-3a9a7dc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "100",
  alt: ""
}, null, -1))
const _hoisted_2 = {
  key: 0,
  src: _imports_1,
  height: "100",
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  src: _imports_2,
  height: "100",
  alt: ""
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "invoice-color" }, "发票号码："),
  /*#__PURE__*/_createTextVNode("2495200000006998082")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-color" }, "开票日期：", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-15" }, null, -1))
const _hoisted_7 = { class: "invoice-body bd-color" }
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "invoice-color bd-right",
  style: {"width":"18px","padding":"3px","box-sizing":"content-box"}
}, "购买方信息", -1))
const _hoisted_10 = {
  style: {"flex":"1","flex-direction":"column"},
  class: "d-flex justify-content--around pl-10"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-color" }, "名称:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-color" }, "统一社会信用代码/纳税人识别号:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "invoice-color bd-right bd-left",
  style: {"width":"18px","padding":"3px","box-sizing":"content-box"}
}, "销售方信息", -1))
const _hoisted_14 = {
  style: {"flex":"1","flex-direction":"column"},
  class: "d-flex justify-content--around pl-10"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-color" }, "名称:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-color" }, "统一社会信用代码/纳税人识别号:", -1))
const _hoisted_17 = {
  class: "bd-top background-text",
  "data-content": "样     票"
}
const _hoisted_18 = {
  colspan: "0",
  cellpadding: "0",
  cellspacing: "0",
  style: {"width":"100%"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "invoice-color" }, [
  /*#__PURE__*/_createElementVNode("th", null, "项目名称"),
  /*#__PURE__*/_createElementVNode("th", null, "规格型号"),
  /*#__PURE__*/_createElementVNode("th", null, "单位"),
  /*#__PURE__*/_createElementVNode("th", null, "数量"),
  /*#__PURE__*/_createElementVNode("th", null, "单价"),
  /*#__PURE__*/_createElementVNode("th", null, "金额"),
  /*#__PURE__*/_createElementVNode("th", null, "税率/征收率"),
  /*#__PURE__*/_createElementVNode("th", null, "税额")
], -1))
const _hoisted_20 = { style: {"text-align":"center"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "6%", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "invoice-color bd-top",
  colspan: "5"
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"80px"} }),
  /*#__PURE__*/_createTextVNode(" 合"),
  /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"80px"} }),
  /*#__PURE__*/_createTextVNode("计")
], -1))
const _hoisted_23 = {
  style: {"text-align":"center"},
  class: "bd-top"
}
const _hoisted_24 = {
  style: {"text-align":"center"},
  class: "bd-top",
  colspan: "2"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "invoice-color bd-top bd-right",
  colspan: "1"
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"80px"} }),
  /*#__PURE__*/_createTextVNode("价税合计（大写）")
], -1))
const _hoisted_26 = {
  colspan: "7",
  class: "bd-top"
}
const _hoisted_27 = { class: "big-money" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-color" }, "小写", -1))
const _hoisted_29 = { class: "d-flex bd-top" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "invoice-color bd-right",
  style: {"width":"18px","padding":"0px 3px","box-sizing":"content-box","line-height":"50px"}
}, "备注", -1))
const _hoisted_31 = { style: {"flex":"1","min-height":"100px"} }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"120px","text-align":"right"} }, "销售方开户银行：", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"120px","text-align":"right"} }, "银行账号：", -1))
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"120px","text-align":"right"} }, "销售方地址：", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"120px","text-align":"right"} }, "电话：", -1))
const _hoisted_38 = { key: 2 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"120px","text-align":"right"} }, "购买方开户银行：", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"120px","text-align":"right"} }, "银行账号：", -1))
const _hoisted_41 = { key: 3 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"120px","text-align":"right"} }, "购买方地址：", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"120px","text-align":"right"} }, "电话：", -1))
const _hoisted_44 = { class: "mt-15" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-30 mt-30 invoice-color" }, " 开票人： ", -1))

import { ref, Ref, reactive, onMounted } from 'vue'
import dayjs from 'dayjs'
import { boolean, string } from 'mathjs'
import { fa } from 'element-plus/es/locale'

export default /*#__PURE__*/_defineComponent({
  props: {
    vatInvoiceForm:{
       default:{
           invoiceType:'ORDINARY'
       } as any
    },
    customInfo:{
       default:{}
    },
    notes:{
        default:""
    },
    itemList:{
        default:[] as any
    }
},
  setup(__props) {

const props = __props


// const amount=ref("")
// const totalAmoutt=ref("")
const  dealBigMoney=(n:any) =>
{  
    var fraction = ['角', '分'];  
    var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];  
    var unit = [ ['元', '万', '亿'], ['', '拾', '佰', '仟']  ];  
    var head = n < 0? '欠': '';  
    n = Math.abs(n);  

    var s = '';  

    for (var i = 0; i < fraction.length; i++)   
    {  
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');  
    }  
    // s = s || '整';  
    n = Math.floor(n);  

    for (var i = 0; i < unit[0].length && n > 0; i++)   
    {  
        var p = '';  
        for (var j = 0; j < unit[1].length && n > 0; j++)   
        {  
            p = digit[n % 10] + unit[1][j] + p;  
            n = Math.floor(n / 10);  
        }  
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零')  + unit[0][i] + s;  
    }  
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');  
}
const filterItemName=(itemName:string)=>{
    if(!itemName){
        return ""
    }
    let res:any=props.itemList.find((el:any)=>el.name==itemName)
    return res&&res.alias? `${res.alias}*${itemName}`:itemName
}
onMounted(()=>{

})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 12,
          class: "d-flex justify-content--center align-items-center"
        }, {
          default: _withCtx(() => [
            (props.vatInvoiceForm.invoiceType=='ORDINARY')
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : (_openBlock(), _createElementBlock("img", _hoisted_3))
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 6,
          class: "d-flex justify-content--center",
          style: {"flex-direction":"column"}
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createElementVNode("div", null, [
              _hoisted_5,
              _createTextVNode(_toDisplayString(_unref(dayjs)().format('YYYY-MM-DD')), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _hoisted_11,
            _createTextVNode(_toDisplayString(props.vatInvoiceForm.buyerName||''), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_12,
            _createTextVNode(_toDisplayString(props.vatInvoiceForm.taxNo||'XXXXXXXXXXXXXXXXXXXXX'), 1)
          ])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, [
            _hoisted_15,
            _createTextVNode(_toDisplayString(props.vatInvoiceForm.sellerName||''), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_16,
            _createTextVNode(_toDisplayString(props.vatInvoiceForm.companyCode||''), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("table", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("tr", _hoisted_20, [
            _createElementVNode("td", null, _toDisplayString(filterItemName(props.vatInvoiceForm.itemName)), 1),
            _createElementVNode("td", null, _toDisplayString(props.vatInvoiceForm.specification), 1),
            _createElementVNode("td", null, _toDisplayString(props.vatInvoiceForm.unit), 1),
            _createElementVNode("td", null, _toDisplayString(props.vatInvoiceForm.quantity), 1),
            _createElementVNode("td", null, _toDisplayString(props.vatInvoiceForm.unitPrice), 1),
            _createElementVNode("td", null, _toDisplayString((props.vatInvoiceForm.totalAmount/1.06).toFixed(2)), 1),
            _hoisted_21,
            _createElementVNode("td", null, _toDisplayString((props.vatInvoiceForm.totalAmount-(props.vatInvoiceForm.totalAmount/1.06)).toFixed(2)), 1)
          ]),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (item) => {
            return _createElementVNode("tr", {
              key: item,
              style: {"opacity":"0"}
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (item2) => {
                return _createElementVNode("td", { key: item2 }, _toDisplayString(item2), 1)
              }), 64))
            ])
          }), 64)),
          _createElementVNode("tr", null, [
            _hoisted_22,
            _createElementVNode("td", _hoisted_23, "￥" + _toDisplayString(props.vatInvoiceForm.totalAmount), 1),
            _createElementVNode("td", _hoisted_24, "￥" + _toDisplayString((props.vatInvoiceForm.totalAmount-(props.vatInvoiceForm.totalAmount/1.06)).toFixed(2)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_25,
            _createElementVNode("td", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", null, _toDisplayString(dealBigMoney((Number(props.vatInvoiceForm.totalAmount).toFixed(2)))) + "整", 1),
                _hoisted_28,
                _createElementVNode("span", null, "￥" + _toDisplayString(props.vatInvoiceForm.totalAmount), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            (props.vatInvoiceForm.showSellerBankInfo||false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _hoisted_33,
                      _createElementVNode("span", null, _toDisplayString(props.vatInvoiceForm.sellerBank) + "；", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _hoisted_34,
                      _createElementVNode("span", null, _toDisplayString(props.vatInvoiceForm.sellerBankAccount) + "；", 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (props.vatInvoiceForm.showSellerAddressAndPhone||false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _hoisted_36,
                      _createElementVNode("span", null, _toDisplayString(props.vatInvoiceForm.sellerAddress) + "；", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _hoisted_37,
                      _createElementVNode("span", null, _toDisplayString(props.vatInvoiceForm.sellerPhone) + "；", 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (props.vatInvoiceForm.showBankInfo||false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _hoisted_39,
                      _createElementVNode("span", null, _toDisplayString(props.vatInvoiceForm.buyerBank) + "；", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _hoisted_40,
                      _createElementVNode("span", null, _toDisplayString(props.vatInvoiceForm.buyerBankAccount) + "；", 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (props.vatInvoiceForm.showAddressAndPhone||false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _hoisted_42,
                      _createElementVNode("span", null, _toDisplayString(props.vatInvoiceForm.buyerAddress) + "；", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _hoisted_43,
                      _createElementVNode("span", null, _toDisplayString(props.vatInvoiceForm.buyerPhone) + "；", 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_44, _toDisplayString(props.notes), 1)
          ])
        ])
      ])
    ]),
    _hoisted_45
  ]))
}
}

})